<template>
    <div class="iframe-container">
        <div v-if="errorMsg" class="error">
            {{ errorMsg }}
        </div>
        <iframe
            v-else
            v-bind:src="iframeUrl"
            allow="fullscreen"
            height="100%"
            width="100%"
        />
    </div>
</template>

<script lang="ts">
    import { defineComponent, onBeforeMount, ref } from 'vue';
    import { LiveStreamResource } from '@/interface/enum';
    import Api from '@/libraries/api';

    export default defineComponent ({
        name: 'BetConstructLiveStream',
        props: {
            matchId: {
                type: Number,
                required: true,
            },
        },
        setup(props) {
            const iframeUrl = ref('');
            const errorMsg = ref('');

            onBeforeMount(async () => {
                const { url, errorCode, errorMessage } = await Api.getLiveStream(props.matchId, LiveStreamResource.BetConstruct);
                if (errorCode === 0 && url) {
                    iframeUrl.value = url;
                } else if (errorMessage) {
                    errorMsg.value = errorMessage;
                }
            });

            return {
                iframeUrl,
                errorMsg,
            };
        },
    });
</script>

<style lang="scss" scoped>
.iframe-container {
    position: relative;
    height: 0;
    padding-top: 56.25%; /* 9:16 ratio */
    background-color: rgba(0, 0, 0, 10%);
}

.iframe-container iframe {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    border: none;
}

.error {
    position: absolute;
    top: 0;
    display: flex;
    width: 100%;
    height: 56.25vw;
    align-items: center;
    justify-content: center;
    padding: 3em;
    background-color: rgba(0, 0, 0, 80%);
    color: white;
}
</style>
